import styled from "@emotion/styled";
import {
  AllCaps,
  Container,
  FlexRow,
  H2,
  IconStore,
  Link,
  Stack,
  Text,
} from "atoms";
import { paths } from "utils/paths";

type BannerProps = {
  artistId: string;
};
function StartSellingBanner({ artistId }: BannerProps) {
  return (
    <Wrapper>
      <Container width="lg">
        <FlexRow flexWrap="nowrap" itemsFlex="1 1 auto" gap="10px">
          <IconStore
            primary="fg"
            accent="accent1"
            size="40px"
            style={{ flex: "0 0 40px", alignSelf: "flex-start" }}
          />
          <FlexRow
            justifyContent="space-between"
            itemsFlex="0 1 auto"
            gap="10px"
          >
            <Stack gap="xxs">
              <H2 size="sm">You got access!</H2>
              <Text size="xs" style={{ lineHeight: 1.1 }}>
                Onchain or online, offline or on canvas&mdash;grow & diversify
                your creative revenue with <AllCaps>Hug</AllCaps>.
              </Text>
            </Stack>
            <Link
              variant="primary"
              size="xxxs"
              to={paths.artistShopEdit(artistId)}
            >
              Start Selling
            </Link>
          </FlexRow>
        </FlexRow>
      </Container>
    </Wrapper>
  );
}

const Wrapper = styled.div(({ theme }) => ({
  backgroundColor: theme.colors.accent3LL,
  boxShadow: "inset 0 0 0 1px rgb(0 0 0 / .1)",
  paddingBlock: 20,
}));

export { StartSellingBanner };
